import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PageHeaderBarConfig } from './page-config-api';

@Component({
    selector: 'fw-page-header-bar',
    template: require('./page-header-bar.component.html'),
    styles: [require('./page-header-bar.component.css')]
})
export class PageHeaderBarComponent implements OnInit {
    @Input() config = new PageHeaderBarConfig();

    @Output() btnClick = new EventEmitter<any>();

    constructor() { }

    ngOnInit() {
    }

    btnClicked(event) {
        this.btnClick.emit(event);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/pages/page-header-bar.component.ts